module.exports = __webpack_public_path__ + "static/img/tu3.ea8fdf0e.png";